<template>
  <div>
    <quill-editor
      id="editor"
      ref="myTextEditor"
      v-model="content"
      :options="editorOption"
      :disabled="editor_disabled"
      @change="onEditorChange($event)"
    ></quill-editor>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
// import { BASEURL } from '@/axios/baseUrlConfig.js'
export default {
  name: 'editor',
  data() {
    return {
      content: '',
      editorOption: {
        modules: {
          toolbar: [
            // 加粗 斜体 下划线 删除线
            ['bold', 'italic', 'underline', 'strike'],
            // 颜色
            [{ color: [] }, { background: [] }],
            // 标题
            [{ header: 1 }, { header: 2 }],
            // 对齐方式
            [{ align: [] }],
            // 文字大小
            [{ size: ['small', 'Normal', 'large', 'huge'] }],
            // font family
            // [{ font: [] }],
            // 列表
            [{ list: 'ordered' }, { list: 'bullet' }],
            // 上标下标
            [{ script: 'sub' }, { script: 'super' }],
            // 文本方向
            [{ direction: 'rtl' }],
            // 引用 代码
            ['blockquote', 'code-block']
          ]
        },
        placeholder: '请输入备注'
      },
      // editorHeight: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    editor_disabled: {
      type: Boolean,
      default: false
    },
    editorHeight: {
      type: String,
      default: '200px'
    }
  },
  mounted() {
    this.init()
    this.$refs.myTextEditor.quill.container.style.height = this.editorHeight // 初始化高度
  },
  methods: {
    //  自定义粘贴图片功能
    init() {
      let quill = this.$refs.myTextEditor.quill;
      quill.root.addEventListener('paste', evt => {
        if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
          evt.preventDefault();
          [].forEach.call(evt.clipboardData.files, file => {
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
              return
            }
            this.uploadToServer(file)
          })
        }
      }, false)
    },
    // 修改粘贴图片为上传到服务器
    uploadToServer(file) {
      console.log(file)
      let quill = this.$refs.myTextEditor.quill
      let length = quill.getSelection(true).index;
      //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
      quill.insertEmbed(length, 'image', 'http://192.168.103.29:12025/download/RequirementsGather/1646964543058_459ba17dd6589de9899cf60e7c4c63c5.png?md5=_nog5Y7zUBuW9KMmL9MDdg&expires=1647590543');
      quill.setSelection(length + 1)
    },
    // change事件
    onEditorChange({ html }) {
      this.content = html
      this.$emit('change', this.content)
    },
  },
  components: {
    quillEditor
  },
  watch: {
    // 传入的值
    value: {
      handler(newValue) {
        this.content = newValue
      }
    },
    editorHeight: {
      handler(newValue, oldValue) {
        if (oldValue && newValue) {
          this.$refs.myTextEditor.quill.container.style.height = newValue // 后续监听变化，若有变化时 高度改变
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
// #editor {
// margin-top: 30px;
// margin-right: 10px;
// }
</style>
